import { TRIGGER_OVERLAY } from './types';

export const actionOverlay = overlay => ({
  type: TRIGGER_OVERLAY,
  payload: overlay
});



// WEBPACK FOOTER //
// ./src/store/Overlay/actions.js